import React, {FC, ReactElement} from 'react';
import {
    Cube
  } from '@matthew-roche-io/custom-react-components';
import {ContentPanelContainer} from './content-panel-contaner';
import {ContentPanel} from './content-panel';
import {ContentHeader} from './content-header';
import { Helmet } from 'react-helmet';
import wikihikes1 from '../assets/wikihikes-01.png';
import wikihikes2 from '../assets/wikihikes-02.png';
import wikihikes3 from '../assets/wikihikes-03.png';
import rocheWoodworking from '../assets/roche-woodworking-01.png';
import rochePhotography from '../assets/roche-photography-01.png';
import collegeScoreCard from '../assets/ma-college-scorecard-01.png';

const imageSources = [
    wikihikes1,
    wikihikes2,
    wikihikes3,
    rocheWoodworking,
    rochePhotography,
    collegeScoreCard,
  ]

const cubeFaceStyle: object = {width: '98%'};

interface DescriptionsInterface {
    [key: string]: any;
    front?: ReactElement;
    back?: ReactElement;
    top?: ReactElement;
    bottom?: ReactElement;
    left?: ReactElement;
    right?: ReactElement;
}

const style: object = {fontSize: '16px'};

const descriptions: DescriptionsInterface = {
    front: (<span style={style}>
                <a href="https://wikihikes.com" target="_blank">Wikihikes.com
                </a> is a database-driven website I built in 2017.  It's built
                on PHP with the CodeIgniter framework and uses PostgreSQL as its DBMS.
                The back end is doing a lot 
                with spatial data and the Post GIS extension for PostgreSQL is 
                quite adept at performing spatial queries.  More of a web 'app' than
                a web 'site', I built it originally to allow people to draw their own
                hiking routes on a map and get real-time feedback on the distance traveled and
                elevation gain.  My next personal web project will be to re-write
                this app using React and a RESTful web service written in Node.js.
            </span>),
    back: (<span style={style}><a href="https://photography.roche.works/" target="_blank">Roche Fine-art 
                Photography</a> is another PHP website I built using PosgreSQL.  No front- or back-end 
                frameworks employed here; this is a bare-bones
                PHP site using JavaScript, HTML and CSS.  The site includes an admin page 
                that allows me to upload new photos, delete old photos and update a given photo's 
                information.  I've also incorporated PayPal
                to allow purchase of prints.
                </span>),
    top: (<span style={style}>I built my brother's <a href="https://rochewoodworking.com/" target="_blank">
                Woodworking Website</a> to give his business a web presence.  He's been
                a self-employed carpenter/woodworker his entire adult life and relying solely on 
                word-of-mouth for business can be precarious.  This is another bare-bones PHP-JavaScript-HTML-CSS 
                website (no frameworks).  I did build in an admin page to allow him to upload new photos and
                descriptions of his work.  Visitors also have the ability to submit testimonials and
                upload photos.  Upon submission of a testimonial, my brother receives an email with links allowing 
                him to easily review the testimonial and publish it with the option to include or exclude 
                uploaded photos.
                  </span>),
    bottom: (<span></span>),
    right: (<span style={style}>I built this <a href="https://matthewroche.io/ma-college-scorecard" target="_blank">
                College Scorecard Website</a> a few years ago for a coding challenge.  The rules of 
                the challange were to build a react SPA from scratch (no component libraries) to display 
                the data in a provided JSON file containing Massachusetts College data.  Having a 
                background in GIS, I took the opportunity to incorporate Google Maps.  Per the rules 
                of the challenge, all of the React components were built from scratch.  There's no 
                back-end code in this app.</span>),
    left: (<span></span>),

}

const FrontContent: FC = () => {
  return (
    <img src={wikihikes1} style={cubeFaceStyle}/>
  )
}

const TopContent: FC = () => {
  return (
    <img src={rocheWoodworking} style={cubeFaceStyle}/>
  )
}

const BackContent: FC = () => {
  return (
    <img src={rochePhotography} style={cubeFaceStyle}/>
  )
}

const BottomContent: FC = () => {
  return (
    <img src={wikihikes2} style={cubeFaceStyle}/>
  )
}

const LeftContent: FC = () => {
  return (
    <img src={wikihikes3} style={cubeFaceStyle}/>
  )
}

const RightContent: FC = () => {
  return (
    <img src={collegeScoreCard} style={cubeFaceStyle}/>
  )
}

const cubeFaces = {
    front: <FrontContent/>,
    back: <BackContent/>,
    top: <TopContent/>,
    bottom: <BottomContent/>,
    left: <LeftContent/>,
    right: <RightContent/>,
  };

  interface Props {
    activeSide: string;
  }

export const Portfolio: FC<Props> = ({activeSide}) => {

    const content = descriptions[activeSide];

    return (
        <React.Fragment>
            <Helmet>
                {imageSources.length && imageSources.map(src => {
                return <link rel="preload" as="image" href={src} />
                })}
            </Helmet>
            <div className="cube-content-outer-wrapper">
            <div className="cube-wrapper">
            <Cube 
                faces={cubeFaces} 
                activeSide={activeSide} 
                width={1000}
            />
            </div>
            <div className="description-wrapper">
              <div>
                <ContentPanelContainer>
                    <ContentPanel>
                        {content}
                    </ContentPanel>
                </ContentPanelContainer>
                </div>
            </div>
        </div>
        </React.Fragment>
    )
}